const Space = () => <> </>;

export default Space;
